module.exports = __webpack_public_path__ + "img/spiral-details25.3bd125e8.png";